module.exports = __webpack_public_path__ + "img/Logo.b54e10f9.svg";